module.exports = __webpack_public_path__ + "img/composition-16x9.59b307ff.png";